import { render, staticRenderFns } from "./GameRoute.vue?vue&type=template&id=abd6ae4c&scoped=true&"
import script from "./GameRoute.vue?vue&type=script&lang=js&"
export * from "./GameRoute.vue?vue&type=script&lang=js&"
import style0 from "./GameRoute.vue?vue&type=style&index=0&id=abd6ae4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd6ae4c",
  null
  
)

export default component.exports